
//import '../../scss/master.scss';

import JQuery from 'jquery';

// for Vue
window.$ = window.JQuery = JQuery;

$(document).ready(function() {
	//console.log('App ready!');
});


import Headroom from "headroom.js";


import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import MicroModal from 'micromodal';



function HeadroomStart() {

 	if($(".site-header").length) {
		// select your header or whatever element you wish
		const header = document.querySelector(".site-header");

		const headroom = new Headroom(header);
		headroom.init();

 	}

}



function headerNavToggle() {
	$(".js-menu-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".main-menu").removeClass("is-active");
			$(".site-header").removeClass("is-fixed");
			$(".dropdown-menu").removeClass("is-active");
			$(".main-menu").removeClass("is-pushed");
			$(".main-menu").removeClass("is-pushed-level-2");
		} else {
			$(this).addClass("is-active");
			$(".main-menu").addClass("is-active");
			$(".site-header").addClass("is-fixed");
		}
	});

}

/****************
	Navigation
****************/

function headerDropdownToggle() {


	if (window.innerWidth < 992) {

		$(".js-dropdown-menu-toggle").click(function (e) {
			e.preventDefault();
			if ($(this).siblings(".dropdown-menu").hasClass("is-active")) {
				$(".dropdown-menu").removeClass("is-active");
				$(this).siblings(".dropdown-menu").removeClass("is-active");
				// $(this).removeClass("js-toggle-rotate");
				$(".main-menu").removeClass("is-pushed");

			} else {
				$(".js-dropdown-menu-toggle").removeClass("js-toggle-rotate");
				$(".dropdown-menu").removeClass("is-active");
				$(this).siblings(".dropdown-menu").addClass("is-active");
				// $(this).addClass("js-toggle-rotate");
				$(".main-menu").addClass("is-pushed");

			}
		});
	}

	else {



		// click outside closes menu
		$('body').click(function(e) {
			$(".dropdown-menu").removeClass("is-active");
			$("body").attr('data-overlay', 'off');
			$(".js-dropdown-menu-toggle").removeClass("is-active");
		});
		// click stop propagate on header
		$('.js-site-header').click(function(event){
		    event.stopPropagation();
		});

		$(".js-dropdown-menu-toggle").click(function (e) {
			e.preventDefault();
			if ($(this).siblings(".dropdown-menu").hasClass("is-active")) {
				$(".dropdown-menu").removeClass("is-active");
				$(this).siblings(".dropdown-menu").removeClass("is-active");
				// $(this).removeClass("js-toggle-rotate");
			} else {
				$(".js-dropdown-menu-toggle").removeClass("js-toggle-rotate");
				$(".dropdown-menu").removeClass("is-active");
				$(this).siblings(".dropdown-menu").addClass("is-active");
				// $(this).addClass("js-toggle-rotate");
			}

			if ($(this).hasClass("dropdown-menu__toggle-full-width--hamburger")) {
				if ($(this).hasClass("is-active")) {
					$(this).removeClass("is-active");
					$("body").attr('data-overlay', 'off');
				} else {
					$(this).addClass("is-active");
					$("body").attr('data-overlay', 'on');
				}
			}
		});
	}





}


function subMenuReset() {
	$(".js-dropdown-menu-reset").click(function (e) {
		e.preventDefault();
		if ($(this).closest(".dropdown-menu").hasClass("is-active")) {
			$(this).closest(".dropdown-menu").removeClass("is-active");
			$(".main-menu").removeClass("is-pushed");
		} else {
			$(this).closest(".dropdown-menu").addClass("is-active");
		}
	});
}



function headerDropdownLevelTwoToggle() {
	$(".js-dropdown-menu-level-2-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).siblings(".dropdown-menu-level-2").hasClass("is-active")) {
			$(".dropdown-menu-level-2").removeClass("is-active");
			$(this).siblings(".dropdown-menu-level-2").removeClass("is-active");
			// $(this).removeClass("js-toggle-rotate");
			$(".main-menu").removeClass("is-pushed-level-2");
			// console.log("if");
		} else {
			$(".js-dropdown-menu-toggle").removeClass("js-toggle-rotate");
			$(".dropdown-menu-level-2").removeClass("is-active");
			$(this).siblings(".dropdown-menu-level-2").addClass("is-active");
			// $(this).addClass("js-toggle-rotate");
			$(".main-menu").addClass("is-pushed-level-2");
			// console.log("else");
		}
	});
}


function subMenuLevelTwoReset() {
	$(".js-dropdown-menu-level-2-reset").click(function (e) {
		e.preventDefault();
		if ($(this).closest(".dropdown-menu-level-2").hasClass("is-active")) {
			$(this).closest(".dropdown-menu-level-2").removeClass("is-active");
			$(".main-menu").removeClass("is-pushed-level-2");
		} else {
			$(this).closest(".dropdown-menu-level-2").addClass("is-active");
		}
	});
}


function headerDropdownLevelThreeToggle() {
	$(".js-dropdown-menu-level-3-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).siblings(".dropdown-menu-level-3").hasClass("is-active")) {
			$(".dropdown-menu-level-3").removeClass("is-active");
			$(this).siblings(".dropdown-menu-level-3").removeClass("is-active");
			// $(this).removeClass("js-toggle-rotate");
			$(".main-menu").removeClass("is-pushed-level-3");
			// console.log("if");
		} else {
			$(".js-dropdown-menu-toggle").removeClass("js-toggle-rotate");
			$(".dropdown-menu-level-3").removeClass("is-active");
			$(this).siblings(".dropdown-menu-level-3").addClass("is-active");
			// $(this).addClass("js-toggle-rotate");
			$(".main-menu").addClass("is-pushed-level-3");
			// console.log("else");
		}
	});
}


function subMenuLevelThreeReset() {
	$(".js-dropdown-menu-level-3-reset").click(function (e) {
		e.preventDefault();
		if ($(this).closest(".dropdown-menu-level-3").hasClass("is-active")) {
			$(this).closest(".dropdown-menu-level-3").removeClass("is-active");
			$(".main-menu").removeClass("is-pushed-level-3");
		} else {
			$(this).closest(".dropdown-menu-level-3").addClass("is-active");
		}
	});
}


function headerSearchOpen() {
	$(".js-search-open").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".desktop-search__form").removeClass("is-active");
			$(".desktop-search__close").removeClass("is-active");

		} else {
			$(this).addClass("is-active");
			$(this).next('.desktop-search__form').addClass("is-active");
			$('.desktop-search__close').addClass("is-active");
			$("#search_input").focus();
			$('.desktop-search__input').focus();
		}
	});
}

function headerSearchClose() {
	$(".js-search-close").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".desktop-search__form").removeClass("is-active");
			$(".desktop-search__activator").removeClass("is-active");
		} /*else {
			$(this).addClass("is-active");
			$(this).next('.desktop-search__form').addClass("is-active");
			$('.desktop-search__close').addClass("is-active");
			$("#search_input").focus();
		}*/
	});
}


function headerLangToggle() {
	$(".js-lang-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("is-active")) {
			$(this).removeClass("is-active");
			$(".lang-menu-desktop__list").removeClass("is-active");
		} else {
			$(this).addClass("is-active");
			$(this).next('.lang-menu-desktop__list').addClass("is-active");
		}
	});

}






var membersSwiper = {

	element: '.js-swiper--members',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--members', {
			modules: [Autoplay, Navigation, Pagination, Scrollbar],
			loop: true,
			slidesPerView: 1.9,
			spaceBetween: 64,
			// centeredSlides: true,
			centeredSlides: false,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},

			/*navigation: {
				nextEl: ".members-swiper .swiper-button-next",
				prevEl: ".members-swiper .swiper-button-prev",
			},*/

			/*pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},*/

			
			breakpoints: {
				992: {
					slidesPerView: 4,
					direction: "vertical",
					spaceBetween: 90,
					centeredSlides: true,
				},
			},

			/*init: function(swiper) {
				this.slideTo(getSlideIndexByClass('current'));
			},*/
		});
	},
};




// https://stackoverflow.com/questions/27462306/css3-animate-elements-if-visible-in-viewport-page-scroll
const inViewport = (entries, observer) => {
	entries.forEach(entry => {
		entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
	});
};

const Obs = new IntersectionObserver(inViewport);
const obsOptions = {
	threshold: 1.0, 
}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

// Attach observer to every [data-inviewport] element:
document.querySelectorAll('[data-inviewport]').forEach(el => {
	Obs.observe(el, obsOptions);
});


//
//	KONTAKT FORMA
//


/** funkcija za slanje podataka s kontakt forme - validacija podataka i slanje emaila */
var contactForm = {
	
	// glavni selector
	s: {
		'formId'				: 'contactForm',
		'messageClassError'		: 'contact-form__message-error',
		'messageClassSuccess'	: 'contact-form__message-succsess',
		'elementErrorClass'		: 'has-error',
	},
	
	// glavni form objekt
	formObject: {},
	
	init: function () { 
		this.formObject = document.getElementById(this.s.formId);
		if(this.formObject !== null) {
			this.bindSubmitEvent();
		}
	},

	bindSubmitEvent: function () {
		this.formObject.addEventListener("submit", this.handleSubmit.bind(this));
	},

	handleSubmit: function(event) {
		event.preventDefault();
		
		var self = this;
		
		this.elementHide(contactForm.s.messageClassSuccess);
		this.elementHide(contactForm.s.messageClassError);
		
		
		
		
		
		//this.elementHide("contact-form__field-error");
		
		//remove existing error classes
		$('.' + contactForm.s.elementErrorClass).removeClass(contactForm.s.elementErrorClass);
		
		
		$("span.contact-form__field-error").css('display', 'none');
		
		
		
		//podatci iz forme
		var formData = new FormData(event.target);
		
		// jquery upit
		jQuery.ajax({
			url: langSegment + "xcontact",
			data: formData,
			type: 'POST',
			dataType: 'json',
			contentType: false,
			//contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			processData: false,
			success: function (resData) {
				
				// ako je sve prošlo kako treba
				if (resData['status']) {
					
					// prikazujemo poruku uspješnosti
					contactForm.elementShow(contactForm.s.messageClassSuccess);
					
					// uklanjamo sve eventualne klase errora sa elemenata
					$('.error').removeClass('error');
					
					// resetiramo sve elemente u formi
					document.getElementById(contactForm.s.formId).reset();
					self.formObject.reset();
					
					//scroll to success display
					/*$('html, body').animate({
						scrollTop: $('.xformtop').offset().top - 100
					}, 500);*/
				} else {
					if (resData.errorType == 'validation') {
						//add error classes
						for (var field in resData.form_error) {
							if (resData.form_error[field]) {
								/*if (field == 'email') {
									$('div[data-elname=' + field + ']').addClass(contactForm.s.elementErrorClass);
								} else {
									$('input[name=' + field + ']').addClass(contactForm.s.elementErrorClass);
								}*/
								
								// prikazimo obrub crveni, obično se doda neka error klasa
								$('input[name=' + field + '], textarea[name=' + field + ']').addClass(contactForm.s.elementErrorClass);
								
								// prikaži poruke za obavezna polja po elementima errora
								$("input[name=" + field + "] ~ span.contact-form__field-error").css('display', '');
								$("select[name=" + field + "] ~ span.contact-form__field-error").css('display', '');
								$("textarea[name=" + field + "] ~ span.contact-form__field-error").css('display', '');
							}
						}
					}
					
					// prikaži poruku pogreške
					contactForm.elementShow(contactForm.s.messageClassError);
					
					//scroll to error display
					/*$('html, body').animate({
						scrollTop: $('.xformtop').offset().top - 100
					}, 500);*/
				}
			},
			catch: function (error) {
				
				// prikaži poruku pogreške
				contactForm.elementShow(contactForm.s.messageClassError);
			}
		});
	},
	
	
	/**
	 * funkcija kojom sakrivamo određeni element na stranici
	 * 
	 * @param {string} elementClass 
	 */
	elementHide: function (elementClass) {
		$('.' + elementClass).css('display', 'none');
	},
	
	
	/**
	 * funkcija kojom prikazujemo (otkrivamo) određeni element na stranici
	 * 
	 * @param {string} elementClass 
	 */
	elementShow: function (elementClass) {
		$('.' + elementClass).css('display', '');
	}
}


/**
 * funkcija u koju ćemo stavljati countere u elementima u raznim formama na stranici
 */
var formCharCounter = {
	
	init: function () {
		
		// counter za textarea polje u formi "Contact form"
		$("#contactForm #message").keyup(function () {
			$("#contactForm .counterMessage").text($(this).val().length);
		});
	},
}


//
//	POKRETANJE
//


$(document).ready(function() {
	//console.log('app ready!');

	HeadroomStart();
	headerNavToggle();
	headerDropdownToggle();

	subMenuReset();
	headerDropdownLevelTwoToggle();
	subMenuLevelTwoReset();
	headerDropdownLevelThreeToggle();
	subMenuLevelThreeReset();
	headerSearchOpen();
	headerSearchClose();
	headerLangToggle();

	membersSwiper.init();
	
	contactForm.init();
	formCharCounter.init(); // counter za textarea u kontakt formi
	
});



// administration modals
document.addEventListener("DOMContentLoaded", function() {

	if ( $('.administration-card').length) {

		MicroModal.init({
			awaitCloseAnimation: true,
			onShow: function(modal) {
				// console.log("micromodal open");
			},
			onClose: function(modal) {
				// console.log("micromodal close");
			},
			disableScroll: true, // [6]
			disableFocus: true, // [7]
		});



	}

});